import React from 'react';
import './Speakers from.css';
import Adobe from "../../img/SF/Adobe.png";
import aws from "../../img/SF/aws.png";
import Cloudinary from "../../img/SF/Cloudinary.png";
import Meta from "../../img/SF/Meta.png";
import NextInsurance from "../../img/SF/NextInsurance.png";
import extraordinarytogether from "../../img/SF/extraordinarytogether.png";
import Reactree from "../../img/SF/Reactree.png";
import Salesforce from "../../img/SF/Salesforce.png";
import VueStorefront from "../../img/SF/VueStorefront.png";
import daily from "../../img/SF/daily.png";
import wix from "../../img/SF/wix.png";
import Localize from "../../img/SF/Localize.png";
import VolkswagenDigitalSolutions from "../../img/SF/VolkswagenDigitalSolutions.png";
import Uniform from "../../img/SF/Uniform.png";
import Microsoft from "../../img/SF/Microsoft.png";
import KarkinosHealthcare from "../../img/SF/KarkinosHealthcare.png";
import AngularRocks from "../../img/SF/AngularRocks.png";
import OLXGroup from "../../img/SF/OLXGroup.png";
import Accenture from "../../img/SF/Accenture.png";
import UCraft from "../../img/SF/UCraft.png";
import vmware from "../../img/SF/vmware.png";
import Valtech from "../../img/SF/Valtech.png";
import CapgeminiEngineering from "../../img/SF/CapgeminiEngineering.png";

const SpeakersFrom = (props) => {
    const state = {
        Speakers_item: [
            {
                img: Uniform,
            },
            {
                img: Microsoft,
            },
            {
                img: KarkinosHealthcare,
            },
            {
                img: AngularRocks,
            },
            {
                img: OLXGroup,
            },
            {
                img: Accenture,
            },
            {
                img: UCraft,
            },
            {
                img: vmware,
            },
            {
                img: Valtech,
            },
            {
                img: wix,
            },
            {
                img: Adobe,
            },
            {
                img: Meta,
            },
            {
                img: aws,
            },
            {
                img: NextInsurance,
            },
            {
                img: Cloudinary,
            },
            {
                img: Reactree,
            },
            {
                img: Salesforce,
            },
            {
                img: VueStorefront,
            },
            {
                img: daily,
            },
            {
                img: Localize,
            },
            {
                img: VolkswagenDigitalSolutions,
            },
            {
                img: wix,
            },
            {
                img: extraordinarytogether,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap">
            <div className="container">
                <h3>Speakers from</h3>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;